const url = 'retention_payment';
import { api } from 'api';
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';

const LOADER_RETENTION_PAYMENT = 'LOADER_RETENTION_PAYMENT';
const SET_DATA_RETENTION_PAYMENT = 'SET_DATA_RETENTION_PAYMENT';
const SET_PAGE_RETENTION_PAYMENT = 'SET_PAGE_RETENTION_PAYMENT';
const SET_UPDATE_DATA_RETENTION_PAYMENT = 'SET_UPDATE_DATA_RETENTION_PAYMENT';
const SET_BUSCADOR_RETENTION_PAYMENT = 'SET_BUSCADOR_RETENTION_PAYMENT';
const SET_FILTRO_RETENTION_PAYMENT = 'SET_FILTRO_RETENTION_PAYMENT';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_RETENTION_PAYMENT, cargando: true});
    const store = getStore();
    const search = store.retention_payment.buscador;
    const filtro = store.retention_payment.filtro_retention;
    let params = {page, search};
    if(filtro){
        params[''] = filtro
    }

    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_RETENTION_PAYMENT, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_RETENTION_PAYMENT, data});
            dispatch({type: SET_PAGE_RETENTION_PAYMENT, page});
        }
        dispatch({type: LOADER_RETENTION_PAYMENT, cargando: false});
    })
};

const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_RETENTION_PAYMENT, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_RETENTION_PAYMENT, cargando: false});
        if(error.statusCode === 404){
            dispatch(push('/retention-payment'))
        }
    }).then((data) => {
        dispatch({type: LOADER_RETENTION_PAYMENT, cargando: false});
        if(data){
            console.log("detail: ", data);
            dispatch({type: SET_UPDATE_DATA_RETENTION_PAYMENT, updateData: data});
            dispatch(initializeForm('retentionPaymentForm', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.retentionPaymentForm.values;
    dispatch({type: LOADER_RETENTION_PAYMENT, cargando: true})

    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_RETENTION_PAYMENT, cargando: false})
        Swal('Éxito', 'Se ha creado el rol.', 'success')
        .then(() => {
            dispatch(push('/retention-payment'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_RETENTION_PAYMENT, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_RETENTION_PAYMENT, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.retentionPaymentForm.values);
    dispatch({type: LOADER_RETENTION_PAYMENT, cargando: true});0
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_RETENTION_PAYMENT, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/retention-payment'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_RETENTION_PAYMENT, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/retention-payment/create'));
        }
    })
}

const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_RETENTION_PAYMENT, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_RETENTION_PAYMENT, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
            })
    }).then((data) => {
        dispatch({type: LOADER_RETENTION_PAYMENT, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch) => {
    dispatch({type: SET_BUSCADOR_RETENTION_PAYMENT, buscador: search});
    dispatch(listar(1));
};

const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_RETENTION_PAYMENT, filtro_retention: filtro});
    dispatch(listar(1));
};

const addDocumentNumber = () => (dispatch, getStore) => {
    const formData = { ...getStore().form.form_retention_payment.values };

    api.post(`${url}/addDocumentNumber`, formData).then((data) => {
        dispatch({ type: LOADER_RETENTION_PAYMENT, cargando: false });
        Swal('Éxito', 'Document guardado exitosamente', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    }).catch((error) => {
        dispatch({ type: LOADER_RETENTION_PAYMENT, cargando: false });
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
            });
    });
};

export const actions = {
    listar,
    create,
    update,
    detail,
    destroy,
    search,
    filtro,
    addDocumentNumber,
};

export const reducer = {
    [LOADER_RETENTION_PAYMENT]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_RETENTION_PAYMENT]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_RETENTION_PAYMENT]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_RETENTION_PAYMENT]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_RETENTION_PAYMENT]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_RETENTION_PAYMENT]: (state, { filtro_retention }) => {
        return {...state, filtro_retention }
    },
};

export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_retention: null,
    updateData: {},
};

export default handleActions(reducer, initialState)
